import { graphql } from 'react-relay';

export default graphql`
  query EventCalendarQuery_UserEvent_Refetch_Query (
    $visibility: [UserEventVisibility]
    $booking_status: [BookingStatus]
  ) {
    viewer {
      ...EventCalendarContainer_viewer @arguments(visibility: $visibility, booking_status: $booking_status)
    }
  }
`;



// WEBPACK FOOTER //
// ./webpack/routes/EventCalendarQuery.js